import {ParseResult} from './markdown';

export function tipograph(item: ParseResult): ParseResult {
	return {
		...item,
		content: item.content ? tipographText(item.content) : undefined,
		children: item.children ? item.children.map(tipograph) : undefined,
	};
}

export function tipographText(content: string) {
	const NBSP = '\u00A0';
	const SP = '\u0020';

	// короткие служебные слова
	const shortWords = [
		'в',
		'во',
		'без',
		'до',
		'из',
		'к',
		'ко',
		'на',
		'по',
		'о',
		'от',
		'перед',
		'при',
		'через',
		'с',
		'у',
		'не',
		'за',
		'над',
		'для',
		'об',
		'под',
		'про',
		'и',
		'а',
		'но',
		'да',
		'или',
		'ли',
		'бы',
		'то',
		'что',
		'как',
		'я',
		'он',
		'мы',
		'они',
		'ни',
	].join('|');

	content = content.replace(/\u00A0/g, SP).replace(/[ \t]+/g, SP);

	const shortWordsRe = new RegExp('(^|[^\\p{L}\\p{N}_])(' + shortWords + ')\\u0020', 'giu');

	return content
		.replace(/(\d)\u0020(?=[\dA-Za-z\u0400-\u04FF])/giu, '$1' + NBSP)

		.replace(/\u0020—/g, NBSP + '—')

		.replace(shortWordsRe, `$1$2${NBSP}`)
		.replace(shortWordsRe, `$1$2${NBSP}`)

		.replace(/(\d+d\d+)\u0020([+\-])\u0020(\d+)/giu, `$1${NBSP}$2${NBSP}$3`)

		.replace(/СЛ\u0020(\d+)/g, `СЛ${NBSP}$1`);
}
